import { CommonService } from './../Services/common.service';
import { Component, OnInit } from '@angular/core';
// import { Loader } from '@googlemaps/js-api-loader';
    // for new plugins
import { setOptions, importLibrary } from '@googlemaps/js-api-loader';
    // for new plugins
import { BranchService } from '../Services/branch.service';
import { Router } from '@angular/router';
import { AuthService } from '../Services/auth.service';
import { Subject } from "rxjs";
// import { CookieService } from 'ngx-cookie-service';
import { CookieService } from '../Services/cookie';
import { TicketService } from '../Services/ticket.service';


@Component({
  selector: 'app-branch-locator',
  templateUrl: './branch-locator.component.html',
  standalone:false,
  styleUrls: ['./branch-locator.component.scss']
})
export class BranchLocatorComponent implements OnInit {
  BranchLocationList;
  modalObservable: Subject<void> = new Subject<void>();
  SkipQue: any;
  cpr: string;
  SkipQueBranchList: any;
  SkikQList: any;
  SelectedMarker: any;
  brnchServices: any;
  ServiceId: any;
  branchesID: string;

  constructor(public commonP: CommonService, private tick: TicketService, private cookieService: CookieService,
    public BranchService: BranchService, public _router: Router, public auth: AuthService) { 
    // for new plugins
      setOptions({ key: 'AIzaSyBYg7nf_OzuBSnPvVCg8C2fzcFelf4ZdXo' });
          // for new plugins
    }
  map;
  latitude;
  longitude;
  // loader

  ServicesList: any;
  selectedServices: string = "";
  tourStops: [google.maps.LatLngLiteral][] = [];
  async ngOnInit(): Promise<any> {
    this.commonP.presentLoading();

    let S = await this.cookieService.get("skipque", false);
    if (S) {
      this.SkipQue = S;

    }
    this.cpr = await this.cookieService.get("tempValue", true);





    this.ServicesList = [
      {
        iconClass: "",
        displayValue: "Consumer Finance 1",
      },
      {
        iconClass: "",
        displayValue: "Consumer Finance 2",
      },
      {
        iconClass: "",
        displayValue: "Consumer Finance 3",
      },
      {
        iconClass: "",
        displayValue: "Consumer Finance 4",
      },
    ];
    this.auth.accessToken = await this.commonP.Get("token");

    if (this.SkipQue == "Skipque") {

      this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {
        if (data?.response?.code == 1) {
          this.auth.detailuser = data?.response?.content;
          console.log("detailuser", this.auth.detailuser);

// 
// this.commonP.presentLoading();
let body = {
  UniqueId: this.commonP.Guid(),
  CPR: this.cpr,
  longitude: "108.033",
  latitude: "12.6845983",
  radius: "2147483647"
}
await this.tick.BranchesListDetails(body, this.auth.accessToken).then(async (res: any) => {

  if (res?.response?.code == 1) {
    this.SkipQueBranchList = res.response.content;
    this.SkikQList = this.SkipQueBranchList.list;

    console.log("SkipQueBranchList", this.SkipQueBranchList);

    this.tourStops = this.SkipQueBranchList.list.map(x => ([{
      lat: parseFloat(x.latitude), lng: parseFloat(x.longitude),

    }]));
    console.log('tourStops', this.tourStops);

    //let map : google.maps.Map;
    // for new plugins
    // this.loader.load().then(async (google) => {
    //
    //   let map = await new google.maps.Map(document.getElementById("map"), mapOptions);
    //   this.tourStops.forEach(([position], i) => {
    //     console.log('Position', position)
    //     new google.maps.Marker({
    //       position: position,
    //       map,
    //       label: `${i + 1}`,
    //       optimized: false,
    //       latitude: mapOptions.center.lat,
    //       longitude: mapOptions.center.lng,
    //       zoom: mapOptions.zoom,
    //       gmpClickable: true,
    //       // onTap: this.showModal(1)

    //       //mapType :'satellite',
    //       //   icon: {
    //       //     // url: '../../assets/svg-flags/mapIcon.svg',  // Specify the URL of your custom icon image
    //       //  // scaledSize: new google.maps.Size(40, 40),  // Adjust the size of the icon as needed
    //       //   scaledSize: new google.maps.Size(60, 60),  // Adjust the size of the icon as needed

    //       //   },


    //     });


    //   });

    //   // new google.maps.marker.addListener(("click"),) => {
    //   //   // const { target } = domEvent;
    //   // this.showModal(1);
    //   //   // infoWindow.close();
    //   //   // infoWindow.setContent(marker.title);
    //   //   // infoWindow.open(marker.map, marker);
    //   // });
    // })
    //   .catch(e => {
    //     // do something
    //     console.log("nahi chalrha map")

    //   });


    // /////////////


    // this.commonP.hideLoading();
    // const mapOptions = {
    //   center: {
    //     lat: 26.25473771418154,
    //     lng: 50.626293468438405
    //     // lat: 26254737,
    //     // lng: 50626293
    //   },
    //   zoom: 12
    // };
    // for new plugins
    const mapOptions = {
  center: {
    lat: 26.25473771418154,
    lng: 50.626293468438405
  },
  zoom: 12
};

try {
  const { Map } = await importLibrary("maps") as google.maps.MapsLibrary;
  const { Marker } = await importLibrary("marker") as google.maps.MarkerLibrary;
  let map = new Map(document.getElementById("map") as HTMLElement, mapOptions);
  this.tourStops.forEach(([position], i) => {
    console.log('Position', position);
    new Marker({
      position: position,
      map,
      label: `${i + 1}`,
      optimized: false,
    });
  });
} catch (e) {
  console.log("nahi chalrha map", e);
}

this.commonP.hideLoading();
    // const marker = AdvancedMarkerElement({
    //   // position,
    //   // this.map,
    //   // title: `${i + 1}. ${title}`,
    //   // content: pin.element,
    //   gmpClickable: true,
    // });

  }
  else {

    this.commonP.hideLoading();
    this.commonP.ParseErrorAlert("", "OK", this._router, res);
  }
})
// 






        }
        else {
          await this.commonP.hideLoading();
          // this.commonP.ParseErrorAlert("", "", this._router, data);
        }

      });
      // this.commonP.presentLoading();
      // let body = {
      //   UniqueId: this.commonP.Guid(),
      //   CPR: this.cpr,
      //   longitude: "108.033",
      //   latitude: "12.6845983",
      //   radius: "2147483647"
      // }
      // this.tick.BranchesListDetails(body, this.auth.accessToken).then((res: any) => {

      //   if (res?.response?.code == 1) {
      //     this.SkipQueBranchList = res.response.content;
      //     this.SkikQList = this.SkipQueBranchList.list;

      //     console.log("SkipQueBranchList", this.SkipQueBranchList);

      //     this.tourStops = this.SkipQueBranchList.list.map(x => ([{
      //       lat: parseFloat(x.latitude), lng: parseFloat(x.longitude),

      //     }]));
      //     console.log('tourStops', this.tourStops);

      //     //let map : google.maps.Map;
      //     this.loader.load().then(async (google) => {

      //       let map = await new google.maps.Map(document.getElementById("map"), mapOptions);
      //       this.tourStops.forEach(([position], i) => {
      //         console.log('Position', position)
      //         new google.maps.Marker({
      //           position: position,
      //           map,
      //           label: `${i + 1}`,
      //           optimized: false,
      //           latitude: mapOptions.center.lat,
      //           longitude: mapOptions.center.lng,
      //           zoom: mapOptions.zoom,
      //           gmpClickable: true,
      //           // onTap: this.showModal(1)

      //           //mapType :'satellite',
      //           //   icon: {
      //           //     // url: '../../assets/svg-flags/mapIcon.svg',  // Specify the URL of your custom icon image
      //           //  // scaledSize: new google.maps.Size(40, 40),  // Adjust the size of the icon as needed
      //           //   scaledSize: new google.maps.Size(60, 60),  // Adjust the size of the icon as needed

      //           //   },


      //         });


      //       });

      //       // new google.maps.marker.addListener(("click"),) => {
      //       //   // const { target } = domEvent;
      //       // this.showModal(1);
      //       //   // infoWindow.close();
      //       //   // infoWindow.setContent(marker.title);
      //       //   // infoWindow.open(marker.map, marker);
      //       // });
      //     })
      //       .catch(e => {
      //         // do something
      //         console.log("nahi chalrha map")

      //       });


      //     /////////////


      //     this.commonP.hideLoading();
      //     const mapOptions = {
      //       center: {
      //         lat: 26.25473771418154,
      //         lng: 50.626293468438405
      //         // lat: 26254737,
      //         // lng: 50626293
      //       },
      //       zoom: 12
      //     };
      //     // const marker = AdvancedMarkerElement({
      //     //   // position,
      //     //   // this.map,
      //     //   // title: `${i + 1}. ${title}`,
      //     //   // content: pin.element,
      //     //   gmpClickable: true,
      //     // });

      //   }
      //   else {

      //     this.commonP.hideLoading();
      //     this.commonP.ParseErrorAlert("", "OK", this._router, res);
      //   }
      // })
    }
    else {

      this.commonP.presentLoading();
      this.BranchService.GetBranchListV1().then(async (data: any) => {
        if (data?.response?.code == 1) {
          this.commonP.hideLoading();
          this.BranchLocationList = data.response.content;
          console.log('this.BranchLocationList', this.BranchLocationList);

          this.tourStops = this.BranchLocationList.map(x => ([{
            lat: x.latitude, lng: x.longitude,

          }]));
          console.log('this.tourStops ', this.tourStops);

          //let map : google.maps.Map;
          // for new plugin
          // this.loader.load().then(async (google) => {
          //
          //   let map = await new google.maps.Map(document.getElementById("map"), mapOptions);
          //   this.tourStops.forEach(([position], i) => {
          //     console.log('Position', position)
          //     new google.maps.Marker({
          //       position: position,
          //       map,
          //       label: `${i + 1}`,
          //       optimized: false,
          //       latitude: mapOptions.center.lat,
          //       longitude: mapOptions.center.lng,
          //       zoom: mapOptions.zoom,
          //       //mapType :'satellite',
          //       //   icon: {
          //       //     // url: '../../assets/svg-flags/mapIcon.svg',  // Specify the URL of your custom icon image
          //       //  // scaledSize: new google.maps.Size(40, 40),  // Adjust the size of the icon as needed
          //       //   scaledSize: new google.maps.Size(60, 60),  // Adjust the size of the icon as needed

          //       //   },

          //     });
          //   });


          // })
          //   .catch(e => {
          //     // do something
          //     console.log("nahi chalrha map")

          //   });

          // /////////////

          // // console.log('Locations',this.BranchLocationList);
          // const mapOptions = {
          //   center: {
          //     lat: 26.0667,
          //     lng: 50.5577
          //   },
          //   zoom: 6
          // };
            // for new plugin
// ✅ CHANGE 5: mapOptions pehle, phir importLibrary() se map banaya
const mapOptions = {
  center: {
    lat: 26.0667,
    lng: 50.5577
  },
  zoom: 6
};

try {
  const { Map } = await importLibrary("maps") as google.maps.MapsLibrary;
  const { Marker } = await importLibrary("marker") as google.maps.MarkerLibrary;
  let map = new Map(document.getElementById("map") as HTMLElement, mapOptions);
  this.tourStops.forEach(([position], i) => {
    console.log('Position', position);
    new Marker({
      position: position,
      map,
      label: `${i + 1}`,
      optimized: false,
    });
  });
} catch (e) {
  console.log("nahi chalrha map", e);
}

        }
        else {
          this.commonP.hideLoading();
          this.commonP.ParseErrorAlert('', '', this._router, data);

        }



      });
    }




    // this.loader = new Loader({
    //   //apiKey:'AIzaSyCepTKRvA17x4qhcccC7C81Vw-xaj9PdvA'
    //   // old key development purpose   "AIzaSyCSA70HY1zoLJeB_nG_U2BtLdVsTh5boUU"
    //   // before google consolse AIzaSyB8twUIPjkcB62s3XK2mQYJrSQl_ocM9yw
    //   apiKey: 'AIzaSyBYg7nf_OzuBSnPvVCg8C2fzcFelf4ZdXo', // from BCFC app team
    //   version: "weekly",
    // })



    // Sahi wali
    // apiKey:'AIzaSyBBqi6dsKYBYxATi_Gmvec4B4fR022mupI'

    // const myLatLng = { lat: 56.1304, lng: 106.3468 };
    // const myLatLng = { lat:24.8607, lng: 67.0011};









  }


  showModal(num, item) {

    console.log("items",item);
    this.SelectedMarker = item;
    this.branchesID=item.id
    this.SelectedBranchService();
    this.modalObservable.next(num);
    
    
    console.log("data",this.branchesID );
    

    console.log("SelectedMarker",this.SelectedMarker)
  }

  async SelectedBranchService() {

    let body = {
      UniqueId: this.commonP.Guid(),
      CPR: this.cpr,
      branchID:this.SelectedMarker != undefined ?  this.SelectedMarker.id : '0' 
    }
    // this.SelectedMarker != undefined ?  this.SelectedMarker.id : '0'
    console.log("branchbody",body);
    
    await this.tick.SelectedBranchServices(body, this.auth.accessToken).then((res: any) => {

      if (res?.response?.code == 1) {
        this.brnchServices = res.response.content.list.map(x => ({ displayValue: x.serviceName, serviceId: x.serviceId }))
        console.log("SelectedBranchServices", this.brnchServices);
      }
      else {
        this.commonP.hideLoading();
        this.commonP.ParseErrorAlert("", "OK", this._router, res);
      }
    })
  }

  next() {

    this.cookieService.set("BranchName", this.SelectedMarker != undefined  ? this.SelectedMarker.name: "",true);
    this.cookieService.set("BranchId",   this.SelectedMarker != undefined  ? this.SelectedMarker.id: "",true);
    this.cookieService.set("branchOpen",   this.SelectedMarker != undefined  ? this.SelectedMarker.branchOpen: "",true);
    this.cookieService.set("Cuswait",   this.SelectedMarker != undefined  ? this.SelectedMarker.customersWaiting: "",true);
    this.cookieService.set("estimatedWaitTime",   this.SelectedMarker != undefined  ? this.SelectedMarker.estimatedWaitTime: "",true);
    this.cookieService.set("ServiceName",this.selectedServices,true);
    this.cookieService.set("ServiceId", this.ServiceId,true);
    this.cookieService.set("tempValue", this.cpr,true);
    this._router.navigateByUrl("/BranchTicketIssued");
  }

  async Direction(lat, lng) {

    const mapOptions = {
      center: {
        lat: this.SkipQue == "Skipque" ? parseFloat(lat) : lat,
        lng: this.SkipQue == "Skipque" ? parseFloat(lng) : lng,
      },
      zoom: 15
    };

    //comment 
    // for new plugin
    // this.loader.load().then(async (google) => {
    //   let map = await new google.maps.Map(document.getElementById("map"), mapOptions);
    //   new google.maps.Marker({
    //     position: { lat: lat, lng: lng },
    //     map,
    //     label: `${0 + 1}`,
    //     optimized: false,
    //     latitude: mapOptions.center.lat,
    //     longitude: mapOptions.center.lng,
    //     zoom: mapOptions.zoom,
    //     // mapType :'satellite',
    //     // icon: {
    //     //   // url: '../../assets/svg-flags/mapIcon.svg',  // Specify the URL of your custom icon image
    //     //   scaledSize: new google.maps.Size(40, 40),  // Adjust the size of the icon as needed
    //     // },
    //   });
    // })
    //   .catch(e => {
    //     // do something
    //     console.log("nahi chalrha map")
    //   });
    // for nw plugin
    try {
  const { Map } = await importLibrary("maps") as google.maps.MapsLibrary;
  const { Marker } = await importLibrary("marker") as google.maps.MarkerLibrary;
  let map = new Map(document.getElementById("map") as HTMLElement, mapOptions);
  new Marker({
    position: { lat: lat, lng: lng },
    map,
    label: `${0 + 1}`,
    optimized: false,
  });
} catch (e) {
  console.log("nahi chalrha map", e);
}


  }

  onServicesChange(event) {

    this.ServiceId = event.serviceId;
    this.selectedServices = event.displayValue;


  }


}


